import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { LuArrowLeft, LuArrowRight } from "react-icons/lu";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useOutletContext } from "react-router";
import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay } from "swiper";

const Products = ({ products, homepageInfo }) => {
  const swiperRef = useRef();
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });
  const { url } = useOutletContext();

  const clickSwiperButton = (isPrev = true) => {
    if (swiperRef.current) {
      if (isPrev) {
        swiperRef.current.swiper.slidePrev();
      } else {
        swiperRef.current.swiper.slideNext();
      }
    }
  };

  return products && Array.isArray(products) && products.length > 0 ? (
    <div className="products">
      <div className="label">
        <span>인기상품</span>
        <span className="description">
          {homepageInfo?.cmpnyNm}의 인기상품을 {isMobile && <br />}한눈에 확인할 수 있습니다.
        </span>
      </div>
      <div className="preview">
        <button className="action" onClick={() => clickSwiperButton()}>
          <LuArrowLeft />
        </button>
        <Swiper
          ref={swiperRef}
          className="mySwiper"
          loop
          observer={true}
          observeParents={true}
          autoplay={{ delay: 0, disableOnInteraction: false }}
          speed={1000}
          spaceBetween={30}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            767: {
              slidesPerView: 2,
            },
            1050: {
              slidesPerView: 3,
            },
          }}>
          {products.map((item, i) => (
            <SwiperSlide
              className="box"
              onClick={() => navigate(`/shop/${url}/productsView/${item.id}`)}>
              <div className="image">
                <img src={imgHandler(item.media)} onError={onErrorImg} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <button className="action" onClick={() => clickSwiperButton(false)}>
          <LuArrowRight />
        </button>
      </div>
    </div>
  ) : null;
};

export default Products;
